"use client"
import { init, push } from "@socialgouv/matomo-next"
import { usePathname, useSearchParams } from "next/navigation"
import { Suspense, useEffect, useRef, useState } from "react"

const MATOMO_URL = process.env.NEXT_PUBLIC_MATOMO_URL
const MATOMO_SITE_ID = process.env.NEXT_PUBLIC_MATOMO_SITE_ID

const MatomoComponent = () => {
  const [initialised, setInitialised] = useState(false)
  useEffect(() => {
    if (MATOMO_URL && MATOMO_SITE_ID && !initialised) {
      init({
        url: MATOMO_URL,
        siteId: MATOMO_SITE_ID,
        disableCookies: true,
      })
    }
    return () => {
      setInitialised(true)
    }
  }, [initialised, setInitialised])

  const searchParams = useSearchParams(),
    pathname = usePathname()
  const isInitialLoad = useRef(true)
  const searchParamsString = searchParams.toString()
  useEffect(() => {
    console.log("change")
    console.log(pathname)
    if (isInitialLoad.current) {
      isInitialLoad.current = false
    } else {
      if (!pathname) {
        return
      }
      // may be necessary to decodeURIComponent searchParamsString ?
      const url = pathname + (searchParamsString ? "?" + searchParamsString : "")
      push(["setCustomUrl", pathname + searchParamsString])
      push(["trackPageView"])
    }
  }, [pathname, searchParamsString])
  return null
}

export default function Matomo() {
  return (
    <Suspense fallback={<></>}>
      <MatomoComponent />
    </Suspense>
  )
}
